import { Component } from '@angular/core';
import { ActivityInternalTableComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-activity-internal-table',
    templateUrl: './sjoborg-activity-internal-table.component.html',
    styleUrls: ['./sjoborg-activity-internal-table.component.scss'],
    standalone: false
})
export class SjoborgActivityInternalTableComponent extends ActivityInternalTableComponent {}
